module.exports = __webpack_public_path__ + "img/wallet_bg.9e73d445.png";